<template>
    <div>

        <div class="form-group row" style="margin-bottom: 0;">
            <div class="col-md-12">
                <v-select :value.sync="value.country"
                          :placeholder="$t('select_country')"
                          :options="countries"
                          label="name"
                          :on-change="onCountryChange"
                          :class="hasErrorCountry"
                          :get-option-label="optionLabel"></v-select>
                <div class="help-block invalid-feedback"
                     v-if="!value.country && errors.has('country_id') || !value.country && errors.has('city_id')"
                     style="display: block;margin-bottom: 5px;">Поле <strong>{{ $t('country') }}</strong> є обов'язковим для заповнення.</div>
            </div>
            <div class="col-md-12">
                <v-select :value.sync="value.region"
                          v-if="showRegion"
                          :placeholder="$t('select_region')"
                          :options="regions"
                          label="name"
                          :disabled="isRegionDisabled"
                          :on-change="onRegionChange"
                          :class="hasErrorRegion"
                          :get-option-label="optionLabel"></v-select>
                <div class="help-block invalid-feedback"
                     v-if="showRegion && (errors.has('region_id') || !value.region && errors.has('city_id'))"
                     style="display: block;margin-bottom: 5px;">Поле <strong>{{ $t('region') }}</strong> є обов'язковим для заповнення.</div>
            </div>
            <div class="col-md-12">
                <v-select :value.sync="value.city"
                          v-if="showCity"
                          :placeholder="$t('select_city')"
                          :options="cities"
                          :disabled="isCityDisabled"
                          label="name"
                          :on-change="onCityChange"
                          :class="hasErrorCity"
                          :get-option-label="optionLabel"></v-select>
                <div class="help-block invalid-feedback"
                     v-if="showCity && !value.city && errors.has('city_id')"
                     style="display: block;margin-bottom: 5px;">Поле <strong>{{ $t('city') }}</strong> є обов'язковим для заповнення.</div>
            </div>
        </div>
    </div>
</template>

<script>
    import vSelect from 'vue-select';
    import { mapGetters } from 'vuex';
    import _ from 'lodash';

    export default {
        name: 'ss_location',

        components: {vSelect},

        props: {
            /**
             * @type Object
             **/
            value: {
                type: Object,
                default: function () {
                    return {
                        country: null,
                        region: null,
                        city: null
                    };
                }
            },

            errors: {
                type: Object,
                default: () => {
                    return {
                        country_id: [],
                        region_id: [],
                        city_id: []
                    }
                }
            },

            showRegion: {
                type: Boolean,
                default: true
            },

            showCity: {
                type: Boolean,
                default: true
            }
        },

        data() {
            return {
            }
        },

        computed: {
            ...mapGetters({
                countryObjects: 'getCountries',
                regionsByCountry: 'getRegionsByCountryCode',
                citiesByRegion: 'getCitiesByRegionId'
            }),

            /**
             *
             */
            countries() {
                return this.countryObjects;
            },

            hasErrorCountry() {
                if (!_.isObject(this.value.country) && (this.errors.has('country_id') || this.errors.has('region_id') || this.errors.has('city_id'))) {
                    return 'is-invalid';
                } else if(_.isObject(this.value.country)) {
                    return 'is-valid';
                }
            },

            hasErrorRegion() {
                if (this.showRegion) {
                    if (this.showCity === true) {
                        if (!_.isObject(this.value.region) && (this.errors.has('region_id') || this.errors.has('city_id'))) {
                            return 'is-invalid';
                        } else if (_.isObject(this.value.region)){
                            return 'is-valid';
                        }
                    }
                }
            },

            hasErrorCity() {
                if (this.showCity) {
                    if (!_.isObject(this.value.city) && this.errors.has('city_id')) {
                        return 'is-invalid';
                    } else if (_.isObject(this.value.city)){
                        return 'is-valid';
                    }
                }
            },

            /**
             *
             */
            regions() {
                return this.regionsByCountry(this.value.country ? this.value.country.code : '');
            },

            /**
             *
             */
            cities() {
                return this.citiesByRegion(this.value.region ? this.value.region.id : '');
            },

            /**
             *
             */
            isRegionDisabled() {
                return this.regions.length === 0;
            },

            /**
             *
             */
            isCityDisabled() {
                return this.cities.length === 0;
            }
        },

        created: function () {
            this.$store.dispatch('parseCountryJson')
                .finally(() => {
                    if (this.countries.length === 1) {
                        this.$set(this.value, 'country', _.first(this.countries));
                    }
                });
        },

        methods: {
            /**
             *
             * @param country
             */
            onCountryChange(country) {
                this.$set(this.value, 'region', null);
                this.$set(this.value, 'city', null);
                this.$set(this.value, 'country', country);
            },

            /**
             *
             * @param region
             */
            onRegionChange(region) {
                this.$set(this.value, 'city', null);
                this.$set(this.value, 'region', region);
            },

            /**
             *
             * @param city
             */
            onCityChange(city) {
                this.$set(this.value, 'city', city);
            },

            /**
             *
             * @param item
             */
            optionLabel(item) {
                return item.name;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/common/ss_locations.vue